/* FULLHED , product buy-box + shade quiz controller.
   Handles shade selection, the three offer cards, add-to-cart across offers
   (subscription selling plan, separate starter product, buy-2-get-1 discount),
   cart attributes, and the shade quiz overlay. Every step emits fhTrack events. */
(function () {
  var track = window.fhTrack || function () {};

  function money(cents, format) {
    // Minimal Shopify money formatter (handles {{amount}} with 2 decimals)
    var value = (cents / 100).toFixed(2);
    if (!format) return 'A$' + value;
    return format.replace(/\{\{\s*amount\s*\}\}/, value)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function initProduct(root) {
    var data = JSON.parse(root.querySelector('[data-fh-pdp-data]').textContent);
    var state = { shade: data.defaultShade, offer: data.defaultOffer };

    var shadeInputs = root.querySelectorAll('[data-fh-shade]');
    var offerInputs = root.querySelectorAll('[data-fh-offer]');
    var ctaLabel = root.querySelector('[data-fh-cta-label]');
    var ctaPrice = root.querySelector('[data-fh-cta-price]');
    var atc = root.querySelector('[data-fh-atc]');
    var shadeName = root.querySelector('[data-fh-shade-name]');
    var sticky = root.querySelector('[data-fh-sticky]');
    var stickyPrice = root.querySelector('[data-fh-sticky-price]');
    var stickyCtaPrice = root.querySelector('[data-fh-sticky-cta-price]');
    var stickyBtn = root.querySelector('[data-fh-atc-sticky]');

    function selectShade(shade, viaQuiz) {
      state.shade = shade;
      shadeInputs.forEach(function (el) {
        var on = el.dataset.fhShade === shade;
        el.closest('.fh-shade').classList.toggle('is-selected', on);
        if (on) el.checked = true;
      });
      if (shadeName) shadeName.textContent = shade;
      // swap gallery to the variant image if available
      var v = data.core[shade];
      if (v && v.mediaIndex != null) window.fhGallery && window.fhGallery.go(v.mediaIndex);
      track('fh_shade_select', { shade: shade, sku: v ? v.sku : null, via: viaQuiz ? 'quiz' : 'selector' });
    }

    function selectOffer(offer) {
      state.offer = offer;
      offerInputs.forEach(function (el) {
        var on = el.dataset.fhOffer === offer;
        el.closest('.fh-offer').classList.toggle('is-selected', on);
        if (on) el.checked = true;
      });
      var sel = root.querySelector('[data-fh-offer="' + offer + '"]');
      if (sel) {
        // Label stays "Add to cart" for every offer; only the price changes.
        var price = sel.dataset.ctaPrice || '';
        if (ctaPrice) ctaPrice.textContent = price;
        if (stickyCtaPrice) stickyCtaPrice.textContent = price;
        if (stickyPrice) stickyPrice.textContent = price;
      }
      track('fh_offer_select', { offer: offer });
    }

    shadeInputs.forEach(function (el) {
      el.addEventListener('change', function () { selectShade(el.dataset.fhShade); });
    });
    offerInputs.forEach(function (el) {
      el.addEventListener('change', function () { selectOffer(el.dataset.fhOffer); });
    });

    // ---- Add to cart across the three offers ----------------------------
    function cartAttributes() {
      var attrs = { 'Shade': state.shade, 'Offer': state.offer };
      try {
        var q = JSON.parse(localStorage.getItem('fh_quiz') || '{}');
        Object.keys(q).forEach(function (k) { attrs['Quiz: ' + k] = q[k]; });
        var email = localStorage.getItem('fh_email');
        if (email) attrs['Quiz email'] = email;
      } catch (e) {}
      return attrs;
    }

    async function addToCart() {
      atc.disabled = true;
      atc.classList.add('is-loading');
      if (stickyBtn) stickyBtn.disabled = true;
      var offer = state.offer;
      var coreVariant = data.core[state.shade];
      var items = [];
      var redirect = data.cartUrl;

      if (offer === 'subscription') {
        items.push({ id: coreVariant.id, quantity: 1, selling_plan: data.sellingPlanId });
        redirect = '/checkout';
      } else if (offer === 'starter') {
        var kit = data.starter[state.shade] || data.starter[data.defaultShade];
        items.push({ id: kit.id, quantity: 1 });
        redirect = '/checkout';
      } else { // buy 2 get 1 free , one line item per chosen bottle shade
        var selects = root.querySelectorAll('[data-fh-bottle]');
        if (selects.length) {
          selects.forEach(function (sel) {
            var v = data.core[sel.value] || coreVariant;
            items.push({ id: v.id, quantity: 1 });
          });
        } else {
          items.push({ id: coreVariant.id, quantity: data.b2g1Qty });
        }
        // A configured code applies via the discount link; otherwise rely on
        // the store's automatic "BUY 2, GET 1 FREE" discount.
        redirect = data.discount
          ? '/discount/' + encodeURIComponent(data.discount) + '?redirect=/checkout'
          : '/checkout';
      }

      try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: cartAttributes() })
        });
        var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var json = await res.json();
        track('fh_add_to_cart', {
          offer: offer, shade: state.shade,
          items: items.map(function (i) { return { id: i.id, quantity: i.quantity, selling_plan: i.selling_plan || null }; })
        });
        atc.disabled = false;
        atc.classList.remove('is-loading');
        if (stickyBtn) stickyBtn.disabled = false;
        // Open the cart drawer instead of navigating (no page change)
        if (window.fhCart) { window.fhCart.open(); }
        else { window.location.href = redirect; }
      } catch (e) {
        atc.disabled = false;
        atc.classList.remove('is-loading');
        if (stickyBtn) stickyBtn.disabled = false;
        console.error('[FH] add to cart failed', e);
      }
    }

    atc.addEventListener('click', addToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    // Reveal the sticky bar once the main ATC scrolls out of view
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0 });
      io.observe(atc);
    }

    // ---- "Complete your routine" upsell add -----------------------------
    var upsellBtn = root.querySelector('[data-fh-upsell]');
    if (upsellBtn && data.upsell) {
      upsellBtn.addEventListener('click', async function () {
        var v = data.upsell[state.shade] || data.upsell[data.defaultShade] || Object.values(data.upsell)[0];
        if (!v) return;
        upsellBtn.disabled = true;
        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          });
          track('fh_add_to_cart', { offer: 'upsell', shade: state.shade, items: [{ id: v.id, quantity: 1 }] });
          window.location.href = data.cartUrl;
        } catch (e) { upsellBtn.disabled = false; console.error('[FH] upsell add failed', e); }
      });
    }

    // Preselect shade from quiz result / query string
    var params = new URLSearchParams(window.location.search);
    var preShade = params.get('shade') || localStorage.getItem('fh_shade');
    if (preShade && data.core[preShade]) selectShade(preShade);
    else selectShade(state.shade);
    selectOffer(state.offer);

    // Expose for quiz outcome
    window.fhSelectShade = function (shade) { selectShade(shade, true); };
  }

  // ---- Simple gallery ---------------------------------------------------
  function initGallery(root) {
    var track = root.querySelector('.fh-gallery__track');
    var slides = root.querySelectorAll('.fh-gallery__slide');
    var thumbs = root.querySelectorAll('.fh-gallery__thumb');
    var strip = root.querySelector('.fh-gallery__thumbs');
    var i = 0;
    // Keep the active thumb in view inside the horizontal strip (no page scroll)
    function revealThumb() {
      if (!strip || !thumbs[i]) return;
      var sRect = strip.getBoundingClientRect(), tRect = thumbs[i].getBoundingClientRect();
      if (tRect.left < sRect.left || tRect.right > sRect.right) {
        strip.scrollBy({ left: (tRect.left - sRect.left) - 4, behavior: 'smooth' });
      }
    }
    // Reflect the current slide onto the thumbs (no scroll of the main track)
    function setActive(n) {
      i = (n + slides.length) % slides.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      revealThumb();
    }
    // Move the main carousel to slide n and sync the thumbs
    function go(n) {
      var idx = ((n % slides.length) + slides.length) % slides.length;
      if (track && slides[idx]) track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('.fh-gallery__nav--prev');
    var next = root.querySelector('.fh-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    // Native swipe/scroll drives the active slide: derive index from scroll position
    if (track) {
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (idx !== i) setActive(idx);
        }, 60);
      }, { passive: true });
    }
    window.fhGallery = { go: go };
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pdp = document.querySelector('[data-fh-pdp]');
    if (pdp) { initGallery(pdp); initProduct(pdp); }
    // Quiz overlay is handled by fh-quiz.js (loaded globally by the fh-quiz snippet).
  });
})();
